import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useUpdateEverifyUserStatus() {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await api.put("/user/updateuserstatus", body, {
        headers: { "x-company-id": String(body?.companyId) },
      });
      return data;
    },
  });
}
